import { Component } from '@angular/core';
import { GlobalState } from 'app/app.state';
import { ConfigService } from '../../services/config/config.service';

@Component({
    selector: 'appBackdrop',
    templateUrl: './app_backdrop.component.html',
    styleUrls: ['./app_backdrop.component.scss'],
    standalone: false
})
export class AppBackdropComponent
{
    isAppBackdropVisible = false;

    constructor(public config: ConfigService, private _state: GlobalState)
    {
        this._state.subscribe('app.isAppBackdropVisible', () =>
        {
            this.isAppBackdropVisible = this.config.appLayout.isAppBackdropVisible;
        });

	}

    appBackdropClose()
    {
        this.config.appLayout.isAppBackdropVisible = false;
        this._state.notifyDataChanged('app.isAppBackdropVisible', this.config.appLayout.isAppBackdropVisible);

        if (this.config.appLayout.isAppBackdropVisible === false)
        {
            this.config.appLayout.isAppMobileSidebarLeftOpen = false;
            this._state.notifyDataChanged('app.isAppMobileSidebarLeftOpen', this.config.appLayout.isAppMobileSidebarLeftOpen);
			this.config.appLayout.isAppSidebarRightOpen = false;
			this._state.notifyDataChanged('app.isAppSidebarRightOpen', this.config.appLayout.isAppSidebarRightOpen);
        }
    }
}
